import styles from "./Header.module.css";
import { Link, useLocation } from "react-router-dom";
import { routesMap } from "../../routes";

function Header() {
  const {pathname} = useLocation();

  return (
    <header>
      <div className={styles["blue-stripe"]}>
        <div className="container">
          <span className={styles["stripe-span"]}>
            Catalogo nazionale prodotti della motorizzazione
          </span>
        </div>
      </div>
      <div style={{ backgroundColor: "#0066cc" }}>
        <div className="container">
          <div className={styles["header-container"]}>
            <Link to={routesMap.HOME_PAGE} style={{ marginTop: "10px" }}>
              {true ? (
                <img
                  src="https://i.ibb.co/Wn7Xncd/Vettoriale-Logo-MIT-per-web-BIANCO.png"
                  style={{ height: "78px", width: "190px" }}
                  alt="ico white ministero delle infrastrutture e dei trasporti"
                />
              ) : (
                <img
                  src="https://i.ibb.co/jLJrKmy/Vettoriale-Logo-MIT-per-web-GRIGIO.png"
                  style={{ height: "78px", width: "190px" }}
                  alt="ico gray ministero delle infrastrutture e dei trasporti"
                />
              )}
            </Link>
            <div className={styles["a-header"]}>
              <Link
                to={routesMap.HOME_PAGE}
                className={styles["link-header"]}
                style={{ marginRight: "32px",
                fontWeight: pathname === "/" && "bold" 
                }}
              >
                Home
              </Link>
              <Link
                to={`${routesMap.CATALOGO}`}
                className={styles["link-header"]}
                style={{fontWeight: pathname === routesMap.CATALOGO && "bold"}}
                state={{ from: "header" }}
              >
                Catalogo nazionale
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
